<template>
  <div>
    <img class="logo" src="@/assets/images/header-logo.png" alt="">
    <div class="delivery section">
      <div class="grid">
        <div class="grid-item address">
          <ul>
            <li>
              <span>등록일자</span>
              <strong>{{ this.rfnd_req_pit }}</strong>
            </li>
            <li>
              <span>쿠폰번호</span>
              <strong>{{ this.gcct_no }}</strong>
            </li>
            <li>
              <span>상품명</span>
              <strong>{{ this.product_name }}</strong>
            </li>
            <li>
              <span>환불진행상태</span>
              <strong>{{ this.rfnd_State }}</strong>
            </li>
            <li>
              <span>환불금액</span>
              <strong>{{ numberWithCommas(this.refund_amt) }}원</strong>
            </li>
            <li>
              <span>계좌주명</span>
              <strong>{{ this.csmr_name }}</strong>
            </li>
            <li>
              <span>은행명</span>
              <strong>{{ this.rfnd_bank_name }}</strong>
            </li>
            <li>
              <span>계좌번호</span>
              <strong>{{ this.rfnd_acnut_no }}</strong>
            </li>
          </ul>
          <div class="grid-item notice">
            <dl>
              <dt>- 최종 환불금액은 환불 규정에 따라 변동될 수 있습니다.</dt>
              <dt>- 환불사항 관련 문의는 고객센터(1644-4276)로 문의해 주시기 바랍니다.</dt>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';
import axios from 'axios';


export default {
  name: "RefundDetail",
  components: {
    Header,
    Stepper,
  },
  data(){
    return {
      key: this.$route.params.key,
      rfnd_req_pit: '',
      gcct_no : '',
      product_name : '',
      rfnd_State : '',
      refund_amt : '',
      csmr_name : '',
      rfnd_bank_name : '',
      rfnd_acnut_no : ''
    }
  },
  created(){
     axios.get(`${process.env.ENDPOINT}/rfund/detail/${this.key}`)
     .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
        this.rfnd_req_pit = data.response.list.rfnd_req_pit
        this.gcct_no =  data.response.list.gcct_no,
        this.product_name =  data.response.list.product_name,
        this.rfnd_State  =  data.response.list.rfnd_State,
        this.refund_amt  =  data.response.list.refund_amt,
        this.csmr_name  =  data.response.list.csmr_name,
        this.rfnd_bank_name  =  data.response.list.rfnd_bank_name,
        this.rfnd_acnut_no  =  data.response.list.rfnd_acnut_no
        }
        else{
          console.log('detail cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });


    
  },
  methods: {

      numberWithCommas(x) {
      if (!!x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
    }
  }
;
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';

.logo{
  text-align: center;
  margin-left: 100px;
  }
.notice {
  margin-top: 0px !important;
}
select {
  border-radius: 0;
}
.privacy {
  dl {
    dt {
      label {
        background: url(../assets/images/icon_privacy_toggle_bottom.png) no-repeat center right;
      }
      label.on {
        background: url(../assets/images/icon_privacy_toggle_top.png) no-repeat center right;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/RefundDetail.vue